<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle7')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle7') }}</h1>
    <p>{{ $t('artText7-1') }}</p>
    <img
      :src="`${staticUrl}/images/DreamFlat_Revolutionizing_Interior_Design_with_Cutting-Edge_3D_Room_Planning.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText7-2') }}</h2>
    <p>{{ $t('artText7-3') }}</p>
    <h2>{{ $t('artText7-4') }}</h2>
    <p>{{ $t('artText7-5') }}</p>
    <h2>{{ $t('artText7-6') }}</h2>
    <p>{{ $t('artText7-7') }}</p>
    <h2>{{ $t('artText7-8') }}</h2>
    <p>{{ $t('artText7-9') }}</p>
    <h2>{{ $t('artText7-10') }}</h2>
    <p>{{ $t('artText7-11') }}</p>
    <h2>{{ $t('artText7-12') }}</h2>
    <p>{{ $t('artText7-13') }}</p>
    <h2>{{ $t('artText7-14') }}</h2>
    <p>{{ $t('artText7-15') }}</p>
    <h2>{{ $t('artText7-16') }}</h2>
    <p>{{ $t('artText7-17') }}</p>
    <img
      :src="`${staticUrl}/images/DreamFlat_Revolutionizing_Interior_Design_with_Cutting-Edge_3D_Room_Planning_1.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText7-18') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle7')}`,
  ogTitle: `${t('artSeoTitle7')}`,
  description: `${t('artSeoDesc7')}`,
  ogDescription: `${t('artSeoDesc7')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
